import { useParams } from "react-router-dom";
import background from "../../assets/img/backgorund.png";
import { useEffect, useState } from "react";
import { getProjectById } from "../../api/projectApi";

interface Project {
  id: number;
  project_name: string;
  image: string | null;
  description: string;
  status: string;
}

export default function ProjectDetailPage() {
  const { id } = useParams();

  const [loading, setLoading] = useState(true);
  const [project, setProject] = useState<Project | null>(null);

  useEffect(() => {
    fetchProject();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const fetchProject = async () => {
    try {
      setLoading(true);

      const { data } = await getProjectById(Number(id));

      if (data) {
        setProject(data.data);
      }
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <p className="text-lg font-medium text-white">Loading...</p>
      </div>
    );
  }

  if (!project) {
    return (
      <div className="flex h-screen items-center justify-center">
        <p className="text-lg font-medium text-white">Project not found</p>
      </div>
    );
  }

  return (
    <section className="relative min-h-screen overflow-hidden">
      {/* BACKGROUND */}
      <img
        src={background}
        alt=""
        className="absolute inset-0 h-full w-full object-cover"
      />

      {/* HERO */}
      <div className="relative h-[420px] sm:h-[500px] lg:h-[580px]">
        <img
          src={project.image || background}
          alt={project.project_name}
          className="absolute inset-0 h-full w-full object-cover"
        />

        {/* Overlay */}
        <div className="absolute inset-0 bg-black/35" />

        {/* Title */}
        <div className="absolute bottom-12 left-1/2 z-20 w-full max-w-[1200px] -translate-x-1/2 px-6 lg:bottom-16">
          <h1 className="text-3xl font-bold text-white sm:text-4xl lg:text-5xl">
            Detail Project
          </h1>
        </div>
      </div>

      {/* CONTENT */}
      <div className="relative z-10 mx-auto -mt-8 max-w-[1200px] px-6 pb-16 sm:-mt-10 lg:-mt-14 lg:pb-20">
        <div className="rounded-[24px] bg-white p-6 shadow-xl sm:p-8 lg:rounded-[40px] lg:p-10">
          {/* Project Name */}
          <h2 className="mb-6 text-2xl font-bold text-[#2F2F2F] sm:text-3xl lg:mb-8 lg:text-4xl">
            {project.project_name}
          </h2>

          {/* Description */}
          <div className="whitespace-pre-line text-[16px] leading-8 text-[#555] lg:text-[18px] lg:leading-9">
            {project.description}
          </div>
        </div>
      </div>
    </section>
  );
}
